// 新建记忆库术语库——清空
export function removeSentFileUrl(state) {
  state.newForm.sentFileUrlList = []
}

export function removeNewForm(state, option) {
  state.newForm.splice(option, 1)
}

export function setNewForm(state, option) {
  state.newForm = option
}

export function setCompanyCode(state, option) {
  state.myCompanyCode = option
}

export function setFileList(state, option) {
  state.fileList = option
}

export function setSourceLeft(state, option) {
  state.sourceLeft = option
}

export function setSourceRight(state, option) {
  state.sourceRight = option
}

export function set_router(state, option) {
  state.RouterList = option
}

export function setmyTemplate(state, option) {
  state.myTemplate = option
}

export function setUpdateUser(state, option) {
  // 团队管理 修改成员
  state.updateUser = option
}

export function setpersonage(state, option) {
  // 团队管理 修改成员
  state.personageSucceed = option
}

export function setmyRow(state, option) {
  // 团队管理 修改成员
  state.myRow = option
}

export function setybPopover(state, option) {
  // 译贝
  state.ybPopover = option
}

// export function setMemory(state,option){ // 项目设置 记忆库
//     state.MemoryBankList=option;
// }

export function setIsNovice(state, option) {
  // 新手引导
  state.isNovice = option
}

export function setNumOfGuide(state, option) {
  // 新手引导步骤
  state.numOfGuide = option
}
export function setTaskNums(state, payload) {
  // 我的任务数量信息
  state.taskNums = payload
}
